import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectedFilterChip } from '../../models/selected-filter-chip.model';
import { TranslationService } from '../../services/translation.service';
import { CapitalizePipe } from '../../pipes/capitalize.pipe';

@Component({
  selector: 'app-selected-filters',
  standalone: true,
  imports: [CommonModule, CapitalizePipe],
  templateUrl: './selected-filters.component.html'
})
export class SelectedFiltersComponent {
  @Input() chips: SelectedFilterChip[] = [];
  @Input() sort: string = 'score desc';
  @Input() showFiltersPanel = true;
  @Input() hideFilterToggle = false;
  @Input() resultsSummaryText = '';
  @Output() remove = new EventEmitter<{ facetKey: string; value: string }>();
  @Output() clear = new EventEmitter<void>();
  @Output() sortChange = new EventEmitter<string>();
  @Output() toggleFilters = new EventEmitter<void>();

  sortOptions = [
    { value: 'score desc', labelKey: 'sortRelevance' },
    { value: 'nume_str asc', labelKey: 'sortNameAsc' },
    { value: 'nume_str desc', labelKey: 'sortNameDesc' }
  ];

  constructor(private readonly translation: TranslationService) {}

  translate(key: string): string {
    return this.translation.translate(key);
  }

  onRemoveChip(chip: SelectedFilterChip): void {
    this.remove.emit({ facetKey: chip.facetKey, value: chip.value });
  }

  onClear(): void {
    this.clear.emit();
  }

  onSortChange(event: Event): void {
    const select = event.target as HTMLSelectElement;
    this.sortChange.emit(select.value);
  }

  onToggleFilters(): void {
    this.toggleFilters.emit();
  }
}
